import Vue from 'vue'
import App from './App'
import router from './router'
import '@babel/polyfill'
// 全局，公共样式
import './common/css/style.css'
import './common/css/reset.css'
import './common/css/global.css'
// 提示框和加载框
import tip from './components/tip/tip'
// 引入iview
import IView from 'iview'
import 'iview/dist/styles/iview.css';
//pdf方法和打印
import htmlToPdf from './common/JS/htmlTopdf'
import Print from 'vue-print-nb'
// 定义全局变量
import config from './api/config'
Vue.prototype.global = config;

Vue.config.productionTip = false;

// 全局注册
Vue.component('tip', tip);
Vue.use(IView);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});

//下载图片，将页面内容保存为pdf
Vue.use(htmlToPdf);

// 打印方法
Vue.use(Print); //注册




// WEBPACK FOOTER //
// ./src/main.js